import { LibrarianType } from "types/UserType";

export default function LibrarianFlair({ roles }: { roles: LibrarianType[] }) {
  const isLibrarian = roles.indexOf("librarian") !== -1;

  if (!isLibrarian) {
    return false;
  }

  return (
    <div className="text-sm hidden md:flex">
      <span className="bg-blue-500 py-1 px-2 rounded-lg text-white-900">
        Librarian
      </span>
    </div>
  );
}
